module.exports = __webpack_public_path__ + "static/media/fly55invert.eb89edda.png";